'use client'
import React from 'react'
import GlobalStyles from '@/components/PhD/GlobalStyles';
import Hero from '@/components/PhD/Hero';
import About from '@/components/PhD/About';
import Domains from '@/components/PhD/Domains';
import Eligibility from '@/components/PhD/Eligibility';
import AdmissionProcess from '@/components/PhD/AdmissionProcess';
import Fees from '@/components/PhD/Fees';
import Careers from '@/components/PhD/Careers';
import FinalCTA from '@/components/PhD/FinalCTA';
import Breadcrumbs from '@/components/Breadcrumbs';
import EnquiryForm from "@/components/PhD/EnquiryForm"
import { useFormModal } from "@/context/FormContext";

const departmentOptions = [
  { value: "Engineering Science & Technology", label: "Engineering Science & Technology" },
  { value: "Management", label: "Management" },
  { value: "Allied Health Sciences", label: "Allied Health Sciences" },
  { value: "Pharmaceutical Sciences", label: "Pharmaceutical Sciences" },
  { value: "Humanities", label: "Humanities" },
  { value: "Hospitality and Tourism", label: "Hospitality and Tourism" },
];
const PhD = () => {

    const {
        isOpen,
        shouldDownload,
        closeForm,
        handleSuccess,
        openDownloadForm,
        openApplyForm,
        modal,
        closeVideo,
    } = useFormModal();

    const brochureUrl =
        "https://msu-website-all-objects.s3.ap-south-1.amazonaws.com/pdf/PhD_Brochure.pdf";

    const brochureName = "PhD_Brochure.pdf";

    return (
        <>
            <GlobalStyles />
            <div className="min-h-screen bg-white font-sans">
                <Hero
                    onDownload={() => openDownloadForm(brochureUrl, brochureName)}
                    onApply={() => openApplyForm()}
                />
                <Breadcrumbs items={[{ label: "Ph.D." }]} />
                <About />
                <Domains />
                <Eligibility />
                <AdmissionProcess />
                <Fees />
                <Careers />
                <FinalCTA />

                <EnquiryForm
                    isOpen={isOpen}
                    onClose={closeForm}
                    onSuccess={handleSuccess}
                    shouldDownload={shouldDownload}
                    courseDetails={""}
                    specialization={departmentOptions}
                    course={"Ph. D."}
                    schoolName={"School of Doctoral Studies"}
                    stream={""}
                    apiUrl={""}
                />
            </div>
        </>
    )
}

export default PhD